import Pi1 from "../../images/profileImage/pi-set-1-0.png";
import Pi2 from "../../images/profileImage/pi-set-1-1.png";
import Pi3 from "../../images/profileImage/pi-set-1-2.png";
import Pi4 from "../../images/profileImage/pi-set-1-3.png";
import Pi5 from "../../images/profileImage/pi-set-1-4.png";
import Pi6 from "../../images/profileImage/pi-set-1-5.png";
import Pi7 from "../../images/profileImage/pi-set-1-6.png";
import Pi8 from "../../images/profileImage/pi-set-1-7.png";
import Pi9 from "../../images/profileImage/pi-set-1-8.png";
import Pi10 from "../../images/profileImage/pi-set-1-9.png";

import Pi1_L from "../../images/profileImage/large_pi-set-1-0.png";
import Pi2_L from "../../images/profileImage/large_pi-set-1-1.png";
import Pi3_L from "../../images/profileImage/large_pi-set-1-2.png";
import Pi4_L from "../../images/profileImage/large_pi-set-1-3.png";
import Pi5_L from "../../images/profileImage/large_pi-set-1-4.png";
import Pi6_L from "../../images/profileImage/large_pi-set-1-5.png";
import Pi7_L from "../../images/profileImage/large_pi-set-1-6.png";
import Pi8_L from "../../images/profileImage/large_pi-set-1-7.png";
import Pi9_L from "../../images/profileImage/large_pi-set-1-8.png";
import Pi10_L from "../../images/profileImage/large_pi-set-1-9.png";

export default function getProfileImage(fileName, large) {
  switch (fileName) {
    case "pi-set-1-0":
      return large ? (
        <img src={Pi1_L} alt="pi-set-1-0" />
      ) : (
        <img src={Pi1} alt="pi-set-1-0" />
      );
    case "pi-set-1-1":
      return large ? (
        <img src={Pi2_L} alt="pi-set-1-0" />
      ) : (
        <img src={Pi2} alt="pi-set-1-1" />
      );
    case "pi-set-1-2":
      return large ? (
        <img src={Pi3_L} alt="pi-set-1-0" />
      ) : (
        <img src={Pi3} alt="pi-set-1-2" />
      );
    case "pi-set-1-3":
      return large ? (
        <img src={Pi4_L} alt="pi-set-1-0" />
      ) : (
        <img src={Pi4} alt="pi-set-1-3" />
      );
    case "pi-set-1-4":
      return large ? (
        <img src={Pi5_L} alt="pi-set-1-0" />
      ) : (
        <img src={Pi5} alt="pi-set-1-4" />
      );
    case "pi-set-1-5":
      return large ? (
        <img src={Pi6_L} alt="pi-set-1-0" />
      ) : (
        <img src={Pi6} alt="pi-set-1-5" />
      );
    case "pi-set-1-6":
      return large ? (
        <img src={Pi7_L} alt="pi-set-1-0" />
      ) : (
        <img src={Pi7} alt="pi-set-1-6" />
      );
    case "pi-set-1-7":
      return large ? (
        <img src={Pi8_L} alt="pi-set-1-0" />
      ) : (
        <img src={Pi8} alt="pi-set-1-7" />
      );
    case "pi-set-1-8":
      return large ? (
        <img src={Pi9_L} alt="pi-set-1-0" />
      ) : (
        <img src={Pi9} alt="pi-set-1-8" />
      );
    case "pi-set-1-9":
      return large ? (
        <img src={Pi10_L} alt="pi-set-1-0" />
      ) : (
        <img src={Pi10} alt="pi-set-1-9" />
      );
    default:
      return <img src={Pi1} alt="pi-set-1-0" />;
  }
}
